import { render, staticRenderFns } from "./statusForm.vue?vue&type=template&id=0a4d7224&"
import script from "./statusForm.vue?vue&type=script&lang=js&"
export * from "./statusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports